
// 3rd-party modules
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

// project modules
import { useAppDispatch } from "../../hooks/storeHooks";
import { logoutUser } from '../../stores/userStore';
import CreateNewSubscription from "../../components/new-subscription-steps/CreateNewSubscription";

export default function CreateNewSubscriptionPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isNewUser, setIsNewUser] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const userMode = searchParams.get("userMode");

    setIsNewUser(userMode == "new");
  }, [])

  useEffect(() => {
    setLoading(false)
  }, [isNewUser])

  const onCancel = () => {
    dispatch(logoutUser());
    navigate('/');
  };

  const onSave = () => {

  };

  return (
    <>
      {
        !loading &&
        <CreateNewSubscription hasBackButtonOnFirstStep={isNewUser} hasSignup={isNewUser} onCancel={onCancel} onSave={onSave} />
      }
    </>
  );
}
